import { render, staticRenderFns } from "./redactor-text-area.vue?vue&type=template&id=4aac80f4&"
import script from "./redactor-text-area.vue?vue&type=script&lang=js&"
export * from "./redactor-text-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports